export const hasBiometricReaderOptions = [
  { value: 'todos', title: 'Todos' },
  { value: 'true', title: 'SI' },
  { value: 'false', title: 'NO' }
];
